export default __webpack_public_path__ + "../staticImages/pdf-icon.svg";